'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useUAContext } from '@/context/UAContext';
import { fetchCheckUserCommunityPermission } from '@/services/community';
import { HubsStore } from '@/types/store';
const useGetCommunityToggle = () => {
  const $ = _c(4);
  const {
    isMobileApp
  } = useUAContext();
  const {
    appConfig
  } = useConfigsContext();
  const enableCommunity = appConfig?.features?.enable_community === true;
  const enableCommunityMobileApp = appConfig?.features?.enable_community_mobileapp === true;
  let t0;
  if ($[0] !== enableCommunity || $[1] !== enableCommunityMobileApp || $[2] !== isMobileApp) {
    t0 = async credentials => {
      const htcToken = credentials?.htcToken;
      if (!enableCommunity) {
        return false;
      }
      if (isMobileApp && !enableCommunityMobileApp) {
        return false;
      }
      const hasPermission = await fetchCheckUserCommunityPermission(htcToken);
      const communityToggle = hasPermission ? true : false;
      return communityToggle;
    };
    $[0] = enableCommunity;
    $[1] = enableCommunityMobileApp;
    $[2] = isMobileApp;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default useGetCommunityToggle;